// removed by extract-text-webpack-plugin
module.exports = {"header":"_2HDozO5Jm4m4GNjh","transparent":"_3C7y73bQ76AoAzTO"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Popups/PopupHeader.pcss
// module id = 491
// module chunks = 1